import SignUpPrompt from "../Data/Store/SignUpPrompt";

export default class MilestoneActionsListener {

    constructor() {
        window.Broadcast.$on('sign-up-milestone', () => {
            this.promptUserToSignUp();
        })
    }

    promptUserToSignUp() {
        let prompt = new SignUpPrompt();

        prompt.showPrompt();

        setTimeout(() => {
            prompt.showPrompt(false);
        }, 10000);
    }

}
